import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Button, Row, Col } from 'antd';
import TinyMCEEditor from '../common/tinymce-editor-loader';
import AiRegenerateConfirmModal from '../labAssignments/ai-regenerate-modal';

const AiGeneratedResultModal = ({ open, onCancel, questionData, onInsert, handleAiQuestionData }) => {
    const [form] = Form.useForm();
    const [aiQuestionDescriptions, setAiQuestionDescriptions] = useState('');
    const [isAiRegenerateModalOpen, setIsAiRegenerateModalOpen] = useState(false);
    const [selectedQuestion, setSelectedQuestion] = useState(null); // ← store questionData for regenerate modal

    
    const handleAiEditorChange = (content) => {
        setAiQuestionDescriptions(content)
    };

    const handleOpenRegenerateModal = () => {
        setSelectedQuestion(questionData); // pass the current question data
        setIsAiRegenerateModalOpen(true);
        onCancel()
    };
    useEffect(() => {
        if (questionData && open) {
          form.setFieldsValue({
            questionTitle: questionData.questionTitle || '',
            questionDescription: questionData.question || '',
          });
          setAiQuestionDescriptions(questionData.question || '');
        } else {
          form.resetFields();
          setAiQuestionDescriptions('');
        }
      }, [questionData, open, form]);
  return (
    <>
    <Modal
      title="AI Question"
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      destroyOnClose
    >
        <Form form={form} layout="vertical">
            <Row align="end">
                <Button onClick={handleOpenRegenerateModal} style={{ background: '#E75C4A', color: '#fff', border: 'none' }}>
                        Regenerate
                </Button>

            </Row>
            <Form.Item className='poppins-regular'
                name="questionTitle"
                labelCol={{ className: 'poppins-regular' }}
                label="Question Title"
            >
                <Input placeholder="Type the assignment title here. Eg, Lab Question 1" />
            </Form.Item>
            <Form.Item
                name="questionDescription"
                label="Question Description"
                labelCol={{ className: 'poppins-regular' }}
            >
                <TinyMCEEditor 
                    onEditorChange={handleAiEditorChange}
                    initialValue={aiQuestionDescriptions}
                    >
                </TinyMCEEditor>
            </Form.Item>
            <Row align="end" gutter={[16, 16]}>
                <Col>   
                    <Button onClick={onCancel} style={{ borderColor: '#E75C4A', color: '#E75C4A' }}>
                        Cancel
                    </Button>
                </Col>
                <Col>   
                    <Button type="primary" onClick={onInsert} style={{ background: '#E75C4A', border: 'none' }}>
                        Insert
                    </Button>
                </Col>

            </Row>
        </Form>
    </Modal>
    <AiRegenerateConfirmModal
        open={isAiRegenerateModalOpen}
        onCancel={() => setIsAiRegenerateModalOpen(false)}
        questionData={selectedQuestion}
        handleAiQuestionData={handleAiQuestionData}
        />
    </>
  );
};

export default AiGeneratedResultModal;
